import script from "./CRM40_056RPT.vue?vue&type=script&setup=true&lang=js"
export * from "./CRM40_056RPT.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__